import { useEffect, useMemo, useState } from "react";
import { useHeaders } from "ssr-hook";
import { useRouter, useTitle } from "easy-page-router/react";

import { useLang } from "./lang";

// TODO: remove this
export const adminId = "Dfkagy";

export function useHead({ title, description }: { title: string; description: string }) {
    const { lang } = useLang();
    useHeaders({
        lang,
        title,
        description,
        image: `${window.location.origin}/og-image.png?path=${encodeURIComponent(window.location.pathname)}`,
        canonical: window.location.origin + window.location.pathname,
    });
    useTitle(title);
}

function getLocalStorageState(key: string) {
    // for SSR
    if (!global.localStorage) return null;
    return localStorage.getItem(key);
}
function setLocalStorageState(key: string, value: null | string) {
    // for SSR
    if (!global.localStorage) return;
    if (value === null) {
        localStorage.removeItem(key);
    } else {
        localStorage.setItem(key, value);
    }
}

export function useLocalState<T extends string | null>(key: string, defaultValue: T): [T, (value: T) => void] {
    const [state, setState] = useState(defaultValue);

    // for SSR
    useEffect(() => {
        setState(getLocalStorageState(key) as T || defaultValue);
    }, []);

    const setLocalState = useMemo(() => (value: T) => {
        setState(value);
        setLocalStorageState(key, value);
    }, [setState]);

    return [state, setLocalState];
}

export async function handleShare(title?: string, description?: string) {
    const url = window.location.href;
    navigator.clipboard.writeText(url);

    try {
        if (title) {
            await navigator.share({
                url,
                title,
                // text: description,
            });
        } else {
            await navigator.share({ url });
        }
    } catch (err) {

    }
}

export function useWakeLock(lock = true) {
    const { state } = useRouter();

    useEffect(() => {
        if ('wakeLock' in navigator && lock && state === "active") {
            let wakeLock: null | WakeLockSentinel = null;
            navigator.wakeLock.request("screen")
                .then(lock => {
                    wakeLock = lock;
                })
                .catch(() => { });

            return () => {
                wakeLock?.release();
            };
        }
    }, [lock, state]);
}

export function debounce<T extends (...args: any) => any>(func: T, delay: number) {
    let timeoutId: NodeJS.Timeout;

    return function (...args: Parameters<T>) {
        const context = this;

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
}